var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.83,7l1.17,1.17v1.66l-1.17,1.17h-1.66l-1.17-1.17v-1.66l1.17-1.17h1.66Zm8.17-.9v5.8l-.31,1.07-6.96,11.03h-3.47L3.31,12.97l-.31-1.07V6.1l.59-1.41L7.69,.59l1.41-.59h5.8l1.41,.59,4.1,4.1,.59,1.41Zm-2,0L14.9,2h-5.8L5,6.1v5.8l7,11.1,7-11.1V6.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/1773309961/media/icon-location.1e898384c6ba545a7629f2af11e978d0.svg";
export { ForwardRef as ReactComponent };